import React from 'react';
import { DialogInOne, MpTextField } from '../../components';
import { useTranslation } from '../../hooks';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel?: () => void;
  yubiKey: string;
  setYubiKey: React.Dispatch<React.SetStateAction<string>>;
}

const YubiKeyDialog = (props: IProps) => {
  const { isOpen, onClose, onConfirm, onCancel, yubiKey, setYubiKey } = props;

  const { tc } = useTranslation();

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onClose();
    if (onCancel) {
      onCancel();
    }
  };

  const dialogConfig = {
    title: tc('enterYubiKey'),
    self: {
      open: isOpen,
      onClose: () => {
        onClose();
      },
    },
    content: (
      <MpTextField
        label={tc('enterYubiKey')}
        value={yubiKey}
        onChange={(e) => setYubiKey(e.target.value)}
        fullWidth
      />
    ),
    onConfirm: handleConfirm,
    onCancel: handleCancel,
    size: 'sm' as any,
  };

  return <DialogInOne {...dialogConfig} />;
};

export default YubiKeyDialog;
